import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ContactForm } from '../components/forms/ContactForm';
import { ContactChannels } from '../components/ContactChannels';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { SEO } from '../components/SEO';

export function ContactPage() {
  const { t } = useTranslation('contact');
  const location = useLocation();
  const preselectedServiceId = location.state?.serviceId as string | undefined;

  return (
    <div className="min-h-screen bg-dark">
      <SEO
        title="ติดต่อเรา"
        description="ติดต่อ HappyTech สำหรับคำปรึกษาโปรเจกต์ของคุณ เราพร้อมให้บริการและตอบทุกคำถาม ตอบกลับภายใน 24 ชั่วโมง"
        url="https://www.happytech.dev/contact"
        keywords="ติดต่อ HappyTech, สอบถาม, คำปรึกษา, contact, inquiry"
      />
      <Header />
      <main className="pt-16">
        {/* Hero Section */}
        <div className="relative overflow-hidden bg-gradient-to-r from-neon-cyan/20 to-neon-purple/20 py-20">
          {/* Background orbs */}
          <div className="absolute inset-0 overflow-hidden pointer-events-none">
            <div className="orb absolute top-0 left-1/4 w-96 h-96 bg-neon-cyan/10 rounded-full blur-3xl" />
            <div className="orb-delayed absolute bottom-0 right-1/4 w-96 h-96 bg-neon-purple/10 rounded-full blur-3xl" />
          </div>
          <div className="relative max-w-4xl mx-auto px-4 text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-4 font-heading">
              <span className="gradient-text">{t('page.title')}</span>
            </h1>
            <p className="text-xl text-text-secondary max-w-2xl mx-auto">
              {t('page.subtitle')}
            </p>
          </div>
        </div>

        {/* Contact Form Section */}
        <div className="max-w-2xl mx-auto px-4 py-16">
          <div className="glass-card rounded-2xl p-8 md:p-12">
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-text-primary mb-2 font-heading">{t('page.formTitle')}</h2>
              <p className="text-text-secondary">
                {t('page.formDescription')}
              </p>
            </div>

            <ContactForm preselectedServiceId={preselectedServiceId} />
          </div>
        </div>

        {/* Contact Info Cards */}
        <div className="max-w-5xl mx-auto px-4 pb-16">
          <ContactChannels variant="card" />
        </div>
      </main>
      <Footer />
    </div>
  );
}
